import React from 'react';
import { usePageContent } from '../hooks/usePageContent';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';

const Hero = () => {
  const { handleButtonClick } = useButtonLinks();
  const { t } = useTranslation();
  const content = usePageContent('home', {
    heroTitle: t('hero.title'),
    heroSubtitle: '',
    heroDescription: t('hero.subtitle')
  });

  return (
    <>
      {/* Main Hero Section */}
      <section id="home" className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              {t('hero.title')}
            </h1>
            <p className="hero-subtitle">
              {t('hero.subtitle')}
            </p>
            <div className="hero-buttons">
              <button 
                className="btn btn-primary"
                onClick={(e) => handleButtonClick('openAccount', e)}
              >
                {t('hero.createAccount')}
              </button>
              <button 
                className="btn btn-demo"
                onClick={(e) => handleButtonClick('tryDemo', e)}
              >
                <i className="fas fa-play"></i>
                {t('hero.tryDemo')}
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-graphic">
              <div className="floating-card card-1">
                <i className="fas fa-exchange-alt"></i>
                <span>{t('hero.forexTrading')}</span>
              </div>
              <div className="floating-card card-2">
                <i className="fas fa-chart-line"></i>
                <span>{t('hero.indicesStocks')}</span>
              </div>
              <div className="floating-card card-3">
                <i className="fas fa-coins"></i>
                <span>{t('hero.commodities')}</span>
              </div>
              <div className="hero-main-graphic">
                <div className="graphic-circle">
                  <i className="fas fa-globe"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trustworthy Broker Section */}
      <section className="trustworthy-broker">
        <div className="container">
          <div className="broker-content">
            <h2 className="section-title">{t('sections.trustworthyBroker')}</h2>
            <p className="section-subtitle">
              {t('sections.trustworthyDescription')}
            </p>
            <button className="btn btn-primary">{t('hero.createAccount')}</button>
          </div>
        </div>
      </section>

      {/* Award-winning Platform Section */}
      <section className="award-platform">
        <div className="container">
          <div className="platform-content">
            <div className="platform-text">
              <h2 className="section-title">{t('sections.awardWinning')}</h2>
              <p className="section-subtitle">
                {t('sections.awardDescription')}
              </p>
              <button 
                className="btn btn-primary"
                onClick={(e) => handleButtonClick('openAccount', e)}
              >
                {t('hero.createAccount')}
              </button>
            </div>
            <div className="platform-features">
              <div className="feature-item">
                <h3>{t('sections.awardWinning')}</h3>
              </div>
              <div className="feature-item">
                <div className="feature-stat">
                  <span className="stat-number">100+</span>
                  <span className="stat-label">{t('sections.accessToMarkets')}</span>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-stat">
                  <span className="stat-number">20</span>
                  <span className="stat-label">{t('sections.yearsExperience')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;